module.exports = __webpack_public_path__ + "d459557e700834802edab08670a4e26e.svg";